<template>
  <section>
    <!-- Menu -->
    <top-menu/>

    <section>
      <page-header :headerName="'Relatório Completo'" :showBtn="false" :btnName="''" :btnRoute="''"
                   :css="'container-fluid'"/>

      <div class="page-content">
        <div class="container-fluid">
          <div class="row">
            <!-- Loading from page -->
            <!-- Filters -->
            <div class="col-xs-12 col-sm-12 col-md-12">
              <div class="col-xs-12 col-sm-12 col-md-12 default-box filters">
                <div class="col-xs-12 col-sm-12 col-md-12">
                  <div class="col-xs-12 col-sm-6 col-md-3">
                    <div class="form-group">
                      <label>Tipo da pesquisa</label>
                      <select v-model="dataSearch.type">
                        <option value="">Selecione</option>
                        <option value="1">Empresas com mais de X funcionários e menos de Y funcionários</option>
                        <option value="2">Empresas com mais funcionários que o plano Contratado</option>
                        <option value="3">Empresas sem gerar espelho de ponto há X dias</option>
                        <option value="4">Empresas sem marcar ponto há X dias</option>
                        <option value="5">Funcionários demitidos por empresa nos últimos X dias</option>
                        <option value="6">Empresas cadastradas há X dias</option>
                        <option value="7">Empresas com nps respondido nos últimos X dias</option>
                        <option value="8">Empresas com nps médio abaixo de X</option>
                        <option value="9">Empresas com sentimento do dia ativo</option>
                        <option value="10">Empresas que utilizam reconhecimento facial</option>
                        <option value="11">Empresas que utilizam chat</option>
                        <option value="12">Empresa que enviaram comunicado nos últimos X dias</option>
                        <option value="13">Empresas que utilizam cerco eletrônico</option>
                        <option value="14">Últimos Acessos de admin</option>
                        <option value="15">Funcionários readmitidos por empresa nos últimos X dias</option>
                        <option value="16">Empresas com risco de churn</option>
                        <option value="17">FECHAMENTO</option>
                        <option value="18">Quem vai receber NPS</option>
                      </select>
                    </div>
                  </div>
                  <input-checkbox v-if="dataSearch.type != '18'"
                                  @valueCheckbox="value => checkboxIncludeChurned = value" :is-checked="false" :col="3"
                                  :label="'Incluir empresas churnadas'"
                                  style="margin-top: 32px"/>
                </div>
                <div v-if="dataSearch.type" class="col-xs-12 col-sm-12 col-md-12">
                  <div class="col-xs-12 col-sm-12 col-md-12 text-with-input">
                    <p v-if="dataSearch.type === '1'">
                      Empresas com mais de
                      <input v-model="dataSearch.int1" type="text" class="form-control" name="int1" placeholder="10">
                      funcionários e menos de
                      <input v-model="dataSearch.int2" type="text" class="form-control" name="int2" placeholder="05">
                      funcionários
                    </p>
                    <p v-if="dataSearch.type === '2'">Empresas com mais funcionários que o plano Contratado</p>
                    <p v-if="dataSearch.type === '3'">
                      Empresas sem gerar espelho de ponto há
                      <input v-model="dataSearch.int1" type="text" class="form-control" name="int1" placeholder="10">
                      dias
                    </p>
                    <p v-if="dataSearch.type === '4'">
                      Empresas sem marcar ponto há
                      <input v-model="dataSearch.int1" type="text" class="form-control" name="int1" placeholder="10">
                      dias
                    </p>
                    <p v-if="dataSearch.type === '5'">
                      Funcionários demitidos por empresa nos últimos
                      <input v-model="dataSearch.int1" type="text" class="form-control" name="int1" placeholder="10">
                      dias
                    </p>
                    <p v-if="dataSearch.type === '6'">
                      Empresas cadastradas há
                      <input v-model="dataSearch.int1" type="text" class="form-control" name="int1" placeholder="10">
                      dias
                    </p>
                    <p v-if="dataSearch.type === '7'">
                      Empresas com nps respondido nos últimos
                      <input v-model="dataSearch.int1" type="text" class="form-control" name="int1" placeholder="10">
                      dias
                    </p>
                    <p v-if="dataSearch.type === '8'">
                      Empresas com nps médio abaixo de
                      <input v-model="dataSearch.int1" type="text" class="form-control" name="int1" placeholder="5">
                    </p>
                    <p v-if="dataSearch.type === '9'">Empresas com sentimento do dia ativo</p>
                    <p v-if="dataSearch.type === '10'">Empresas que utilizam reconhecimento facial</p>
                    <p v-if="dataSearch.type === '11'">Empresas que utilizam chat</p>
                    <p v-if="dataSearch.type === '12'">
                      Empresa que enviaram comunicado nos últimos
                      <input v-model="dataSearch.int1" type="text" class="form-control" name="int1" placeholder="5">
                      dias
                    </p>
                    <p v-if="dataSearch.type === '13'">Empresas que utilizam cerco eletrônico</p>
                    <p v-if="dataSearch.type === '14'">

                      <input v-model="dataSearch.int1" type="text" class="form-control" name="int1" placeholder="5">
                      dias sem acesso
                    </p>
                    <p v-if="dataSearch.type === '15'">
                      Funcionários readmitidos por empresa nos últimos
                      <input v-model="dataSearch.int1" type="text" class="form-control" name="int1" placeholder="10">
                      dias
                    </p>
                    <p v-if="dataSearch.type === '16'">
                      Empresas sem marcar ponto há
                      <input v-model="dataSearch.int1" type="text" class="form-control" name="int1" placeholder="10">
                      dias
                    </p>
                    <p v-if="dataSearch.type === '17'">
                      Ultimos
                      <input v-model="dataSearch.int1" type="text" class="form-control" name="int1" placeholder="10">
                      dias
                    </p>
                    <p v-if="dataSearch.type === '18'">
                      Clientes que vão receber NPS
                      <input v-model="dataSearch.int1" type="text" class="form-control" name="int1" placeholder="10">
                      Proximos
                      <input v-model="dataSearch.int2" type="text" class="form-control" name="int2" placeholder="05">
                      Dias
                    </p>
                  </div>
                </div>
                <div class="col-xs-12 col-sm-12 col-md-12">
                  <button v-on:click="checkRequest()">Pesquisar</button>
                </div>
              </div>
            </div>

            <full-loading v-if="loadingList"/>

            <!-- No Result -->
            <div v-if="!loadingList && firstSearch && !dataList.length && !failRequest"
                 class="col-xs-12 col-sm-12 col-md-12">
              <div class="col-xs-12 col-sm-12 col-md-12 default-box content-default">
                <p>Nenhum resultado encontrado.</p>
              </div>
            </div>

            <!-- Fail Request -->
            <div v-if="!loadingList && failRequest" class="col-xs-12 col-sm-12 col-md-12">
              <div class="col-xs-12 col-sm-12 col-md-12 default-box content-default">
                <p>Falha na requisição, tente novamente ou contate os DEVS.</p>
              </div>
            </div>

            <!-- Table -->
            <div v-if="!loadingList && firstSearch && dataList.length" class="col-xs-12 col-sm-12 col-md-12">
              <div class="col-xs-12 col-sm-12 col-md-12 default-box orderBy">
                <div class="portlet-title">
                  <div class="caption">
                    <span
                      class="caption-subject font-blue bold uppercase">Quantidade total ({{ dataList.length }})</span>
                  </div>

                  <a v-on:click="downloadActualListExcel()" class="btn-all-excel right" title="Imprimir">
                    <span>Gerar Excel</span>
                    <i class="fa fa-file-excel-o" aria-hidden="true"></i>
                  </a>
                </div>

                <div class="portlet-body contate-table offset-top-20">
                  <div class="table-scrollable table-scrollable-borderless">
                    <table class="table table-hover table-light table-icon">
                      <thead>
                      <tr>
                        <th v-for="c in columns">{{ c }}</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="l in dataList">
                        <td v-for="d in l">{{ d }}</td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </section>
</template>

<script>
import topMenu from "../../components/default/topMenu.vue";
import fullLoading from "../../components/default/fullLoading.vue";
import pageHeader from "../../components/default/pageHeader.vue";

import {
  MASTER_REPORT
} from "../../../../urlConfig";
import {
  REQUEST_SERVICE
} from "../../../../requestConfig";
import {
  UTIL_SERVICE
} from "../../../../requestConfig";
import {
  ALERT_SERVICE
} from "../../../../msgAlertService";
import moment from "moment";
import swal from "sweetalert";
import InputCheckbox from "../../components/inputs/inputCheckbox.vue";

export default {
  name: "report-full",
  components: {
    InputCheckbox,
    topMenu,
    pageHeader,
    fullLoading,
  },
  data() {
    return {
      failRequest: false,
      loadingList: false,
      firstSearch: false,
      dataList: [],
      columns: [],
      checkboxIncludeChurned: false,
      dataSearch: {
        type: '',
        int1: '',
        int2: ''
      },
    }
  },
  methods: {
    downloadActualListExcel() {
      let bodyValue = [];
      let headValue = [];
      let values = [];
      this.columns.map((columns, index) => {
        headValue[index] = columns

        if (this.columns.length === index + 1) {
          this.dataList.map((list, index2) => {
            list.map((value, index3) => {
              if (index3 === 0)
                values = [];

              values[index3] = value;

              if (list.length === index3 + 1) {
                bodyValue[bodyValue.length] = values;
              }
            });

            if (index2 + 1 === this.dataList.length) {
              setTimeout(function () {
                window.downloadListExcel(headValue, bodyValue, "MarQReportao");
              }, 2000);
            }
          });
        }
      });
    },
    createUrl() {
      this.error = {
        type: '',
        int1: '',
        int2: ''
      };

      let url = MASTER_REPORT;
      url += "?type=" + this.dataSearch.type;

      if (this.dataSearch.type === "1") {
        url += "&int1=" + this.dataSearch.int1;
        url += "&int2=" + this.dataSearch.int2;
      }

      if (this.dataSearch.type === "18") {
        url += "&int1=" + this.dataSearch.int1;
        url += "&int2=" + this.dataSearch.int2;
      }

      if (this.dataSearch.type === "17" || this.dataSearch.type === "16" || this.dataSearch.type === "15" || this.dataSearch.type === "14" || this.dataSearch.type === "12" || this.dataSearch.type === "3" || this.dataSearch.type === "4" || this.dataSearch.type === "5" || this.dataSearch.type === "6" || this.dataSearch.type === "7" || this.dataSearch.type === "8") {
        url += "&int1=" + this.dataSearch.int1;

        if (!this.dataSearch.int1) {
          swal({
            title: "Ops...",
            text: "Preencha os valores para continuar.",
            button: "Confirmar",
            icon: 'error'
          });
        }
      }
      if (this.dataSearch.type != '18') {
        url += '&includeChurned=' + this.checkboxIncludeChurned;
      }

      return url;
    },
    getList() {
      this.dataList = [];
      this.loadingList = true;
      this.failRequest = false;
      this.firstSearch = true;

      UTIL_SERVICE.console("URL SEARCH:", this.createUrl());
      REQUEST_SERVICE.get(this.createUrl()).then((response) => {
        UTIL_SERVICE.console("RESULT MASTER_REPORT:", response.data);

        this.columns = response.data.columns.split(",");

        this.dataList = [];
        response.data.listOutput.map((value, index) => {
          this.dataList.push(Object.values(response.data.listOutput[index]));
        });

        this.loadingList = false;
      }).catch((reason) => {
        this.loadingList = false;
        this.failRequest = true;

        ALERT_SERVICE.showMsgError(reason.response.data.erros);
      });
    },
    checkRequest() {
      if (!this.dataSearch.type) {
        swal({
          title: "Ops...",
          text: "Preencha os valores para continuar.",
          button: "Confirmar",
          icon: 'error'
        });

        return
      }

      if (this.dataSearch.type === "1") {
        if (!this.dataSearch.int1 || !this.dataSearch.int2) {
          swal({
            title: "Ops...",
            text: "Preencha os valores para continuar.",
            button: "Confirmar",
            icon: 'error'
          });

          return
        }
      }

      if (this.dataSearch.type === "18") {
        if (!this.dataSearch.int1 || !this.dataSearch.int2) {
          swal({
            title: "Ops...",
            text: "Preencha os valores para continuar.",
            button: "Confirmar",
            icon: 'error'
          });

          return
        }
      }

      if (this.dataSearch.type === "17" || this.dataSearch.type === "16" || this.dataSearch.type === "15" || this.dataSearch.type === "14" || this.dataSearch.type === "12" || this.dataSearch.type === "3" || this.dataSearch.type === "4" || this.dataSearch.type === "5" || this.dataSearch.type === "6" || this.dataSearch.type === "7" || this.dataSearch.type === "8") {
        if (!this.dataSearch.int1) {
          swal({
            title: "Ops...",
            text: "Preencha os valores para continuar.",
            button: "Confirmar",
            icon: 'error'
          });

          return
        }
      }

      this.getList();
    }
  }
}
</script>

<style lang="scss">
.text-with-input {
  p {
    display: inline-block;

    input {
      display: inline-block;
      width: 10%;
      margin: 0 10px;
      border-radius: 4px !important;
      text-align: center;
      min-width: 50px;
    }
  }
}

.btn-all-excel {
  cursor: pointer;
  margin-left: 5px;
  display: inline-block;
  padding: 8px 10px;
  background-color: #00a651;
  color: #fff;
  margin-bottom: 20px;
  border-radius: 4px !important;
  float: right;
  font-weight: 600;
  margin-top: 0;
  border: none;

  i {
    margin-left: 5px;
  }

  &:hover {
    color: #fff;
    background-color: #008d45;
  }
}
</style>



// WEBPACK FOOTER //
// src/vue/pages/restricted/reports/reportFull.vue